import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import axios from "axios";
import toast from "react-hot-toast";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrigtherBig, LightDark, LighterBold, Lightly, smallestText, smallLighterText, smallText } from "../../Assets/CSS/Text";
import { Continuebtn } from "../../Assets/CSS/Button";
import { useNavigate, useSearchParams } from "react-router-dom";


const UploadDocument = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    console.log("...............................", token)
    const [docsState, setDocsState] = useState();
    const [approvedIndex, setApprovedIndex] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const sidebarItems = [
        { id: 1, label: "Personal Info", icon: "proicons:person" },
        { id: 2, label: "Documents", icon: "mi:document" },

    ];

    const activeTab = "Documents"; // change dynamically if needed


    const handleFileUpload = (e, id) => {
        const file = e.target.files[0];
        if (!file) return;

        // Allowed file types
        const allowedTypes = ["application/pdf", "image/png", "image/jpeg"];

        // 🔥 Strict Mime Type Check
        if (!allowedTypes.includes(file.type)) {
            toast.error("Only PDF, PNG, and JPG files are allowed");
            e.target.value = ""; // reset input
            return;
        }

        // 🔥 Fallback extension check (extra safety)
        const allowedExt = ["pdf", "png", "jpg", "jpeg"];
        const fileExt = file.name.split(".").pop().toLowerCase();

        if (!allowedExt.includes(fileExt)) {
            toast.error("please upload only PDF,JPG,JPEG,PNG!");
            e.target.value = "";
            return;
        }

        // Check file size > 5MB
        if (file.size > 5 * 1024 * 1024) {
            toast.error("File size should not exceed 5 MB");
            return;
        }

        const updated = docsState.map((doc) =>
            doc.id === id
                ? {
                    ...doc,
                    file: file.name,
                    size: (file.size / 1024 / 1024).toFixed(2) + " MB",
                    uploadedFile: file,
                    status: "Under Review",
                    statusColor: "#FFFED9",
                }
                : doc
        );

        setDocsState(updated);
    };

    const handleRemoveFile = (id) => {
        setDocsState(prev =>
            prev.map(doc =>
                doc.id === id
                    ? { ...doc, file: "", size: "", status: "" }
                    : doc
            )
        );
    };



    const fetchDocument = async () => {
        if (!token) return toast.error("Token is missing!");

        try {
            setLoading(true);
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/documents/me?token=${token}`
            );

            // Map response to frontend structure
            const formatted = response.data.map((doc) => ({
                id: doc.documentId,
                title: doc.fileName,
                isMandatory: doc.mandatory,
                key: doc.fileName.toLowerCase().replace(/\s+/g, ""), // e.g., "Aadhar card" -> "aadharcard"
                status: doc.fileStatus,
                file: doc.fileUrl || null,
                size: doc.fileSize || "",
                uploadedFile: null,
                statusColor: "#FFE8CC",
                error: "",  // 🔥 add this

                // add these
                firstName: doc.firstName,
                lastName: doc.lastName,
                designation: doc.designation,
            }));

            setDocsState(formatted);
        } catch (error) {
            console.error("Error fetching documents:", error);
            toast.error(error.response?.data?.message || "Failed to fetch documents");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchDocument();
    }, [token]);

    const navigate = useNavigate();
    const handleSubmit = async () => {
        if (!token) return toast.error("Token is missing!");


        // ✅ 1. CHECK MANDATORY DOCUMENTS
        const missingDocs = docsState.filter(doc => !doc.file);

        if (missingDocs.length > 0) {
            toast.error("Please upload all required documents before continuing.");
            return; // ❌ Stop API call
        }


        setLoading(true);

        const formData = new FormData();

        docsState.forEach((doc) => {
            if (doc.uploadedFile) {
                formData.append(`documents[${doc.title}]`, doc.uploadedFile);
            }
        });

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/documents/upload?token=${token}`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            toast.success("Documents submitted successfully!");
            navigate("/document-success");
            fetchDocument();
        } catch (e) {
            console.error(e);
            toast.error(e.response?.data?.message || "Server error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-fluid p-4" style={{ background: "#F8FBFF" }}>
            <nav className="navbar">
                <div className="navbar-left">
                    {/* Hamburger icon for small screens */}
                    <button className="menu-icon">
                        <Icon icon="material-symbols:menu-rounded" width="22" height="22" />
                    </button>
                    <img
                        src={require("../../Assets/Images/EMS-logo.png")}
                        alt="Company Logo"
                        className="navbar-logo"
                    />
                </div>

            </nav>
            <div className="row" >

                {/* LEFT SIDEBAR */}
                <div className="col-12 col-md-3 mt-5 mb-5">
                    <div className="card p-3 shadow-sm border-0 mb-2"
                        style={{
                            borderRadius: "12px",
                            flexDirection: 'column',
                            height: '136px',
                            alignItems: 'start'

                        }}>

                        <div className="d-flex align-items-center gap-3 text-start">

                            {/* Profile Circle */}
                            <div
                                className="rounded-circle d-flex align-items-center justify-content-center"
                                style={{
                                    width: "60px",
                                    height: "60px",
                                    background: "#E5F6FF",
                                    color: "#00AFEF",
                                    fontWeight: "600",
                                    fontSize: "22px",
                                }}
                            >
                                {docsState?.[0]?.firstName?.charAt(0)}
                                {docsState?.[0]?.lastName?.charAt(0)}
                            </div>

                            {/* Name + Role */}
                            <div className="d-flex flex-column">
                                <h6 className="mb-0 fw-bold">{docsState?.[0]?.firstName} {docsState?.[0]?.lastName}</h6>
                                <p className="text-muted small mb-0"> {docsState?.[0]?.designation}</p>
                            </div>
                        </div>


                        {/* Progress */}

                        <div
                            className="mt-4 d-flex flex-column"

                        >
                            <div className="d-flex justify-content-between align-item-center">
                                <h6 style={{ ...Lightly, marginBottom: "0" }}>Progress</h6>
                                <small style={smallText}>2/4</small>
                            </div>

                            <div className="d-flex align-items-center gap-2">

                                {/* Dynamic Progress Steps */}
                                <div className="d-flex gap-1">
                                    {[1, 2, 3, 4].map((step) => (
                                        <div
                                            key={step}
                                            style={{
                                                width: "50px",
                                                height: "4px",
                                                borderRadius: "4px",
                                                backgroundColor: step <= 2 ? "#00AFEF" : "#D8D8D8", // 2/4
                                            }}
                                        ></div>
                                    ))}
                                </div>

                                {/* Count */}

                            </div>

                        </div>
                    </div>
                    <div className=" p-3 border-0"
                        style={{
                            borderRadius: "12px",
                            flexDirection: 'column',
                            height: '250px'

                        }}>



                        <ul className="list-group mt-3" style={{ background: "#F5FCFE" }}>
                            {sidebarItems.map((item) => (
                                <li
                                    key={item.id}
                                    className={`list-group-item border-0 ${activeTab === item.label ? "active" : ""}`}
                                    style={{
                                        background: activeTab === item.label ? "#F5FCFE" : "transparent",
                                        color: activeTab === item.label ? "#00AFEF" : "#000",
                                        cursor: "pointer",
                                    }}
                                >
                                    {item.icon && <Icon icon={item.icon} className="me-2" />}
                                    {item.label}
                                </li>
                            ))}
                        </ul>

                    </div>
                </div>

                {/* RIGHT MAIN CONTENT */}
                <div className="col-12 col-md-9 mt-5 mb-5">
                    <div className="card p-4 shadow-sm border-0"
                        style={{
                            borderRadius: "12px",
                            flexDirection: 'column',
                            height: '100%',
                            alignItems: 'start'
                        }}>
                        <h4 style={{ ...BrigtherBig, textAlign: 'left' }}>Upload Documents</h4>
                        <p style={Lightly}>
                            Please upload the required documents to complete your onboarding process
                        </p>

                        {/* DOCUMENT LIST */}

                        {docsState?.map((doc, index) => (
                            <div
                                key={index}
                                className="card mb-3 px-3 d-flex flex-row align-items-center 
                                justify-content-between doc-row"
                                style={{
                                    backgroundColor: "#FFFFFF",
                                    boxShadow: "none",
                                    border: "1px solid #DBDBDB",
                                    height: "85px",
                                    width: "100%",
                                    padding: '15px 10px'
                                }}
                            >
                                {/* LEFT SIDE */}
                                <div className="d-flex align-items-center gap-3">

                                    {/* Document Icon */}
                                    <div
                                        className="rounded-circle d-flex justify-content-center align-items-center"
                                        style={{
                                            width: "55px",
                                            height: "55px",
                                            backgroundColor: "#EFEFEF",
                                            border: "1px solid #F0F0F0",
                                        }}
                                    >
                                        <Icon icon="mi:document" style={{ color: "#C1C1C1", fontSize: "24px" }} />
                                    </div>

                                    {/* Title + File Types */}
                                    <div>
                                        <h6 style={{ ...LightDark, margin: 0 }}>
                                            {doc.title}
                                            {doc.isMandatory && <span style={{
                                                fontSize: '14px',
                                                fontWeight: '400',
                                                color: '#E00000'
                                            }}>*</span>}
                                        </h6>

                                        <p style={{ margin: 0, fontSize: "12px", color: "#6f6f6f" }}>
                                            PDF, PNG, JPG (MAX 5mb)
                                        </p>
                                    </div>
                                </div>



                                {/* RIGHT SIDE BUTTONS */}
                                <div className="d-flex align-items-center justify-content-between" style={{
                                    width: "60%",

                                }}>

                                    {/* COLUMN 1 → FILE NAME / UPLOAD */}

                                    <div className="d-flex align-items-center gap-2" style={{ width: "71%" }}>

                                        {!doc.file || doc.status === "REJECTED" ? (

                                            <div className="d-flex flex-column" style={{ width: "300px" }}>

                                                <button
                                                    className="btn d-flex align-items-center gap-1 px-4 py-3"
                                                    style={{
                                                        backgroundColor: "#DDF6FF",
                                                        color: "#00AFEF",
                                                        borderRadius: "10px",
                                                        width: "100%", // keep consistent
                                                    }}
                                                    onClick={() => document.getElementById(`fileInput-${doc.id}`).click()}
                                                >
                                                    <Icon icon="material-symbols:upload" width="18" />
                                                    Upload document <span style={smallLighterText}>(max. 5 MB)</span>
                                                </button>


                                                <input
                                                    type="file"
                                                    id={`fileInput-${doc.id}`}
                                                    className="d-none"
                                                    accept="application/pdf,image/png,image/jpeg"
                                                    onChange={(e) => handleFileUpload(e, doc.id)}
                                                />
                                            </div>
                                        ) : (
                                            <>

                                                <div
                                                    className="px-3 py-3 d-flex align-items-center"
                                                    style={{
                                                        ...LighterBold,
                                                        borderRadius: "10px",
                                                        width: "300px",
                                                        background:
                                                            doc.status === "APPROVED"
                                                                ? "#EFEFEF"
                                                                : "#DAFFE8",
                                                        color: "#606060",
                                                        justifyContent: "space-between"   // 🔥 creates bigger space
                                                    }}
                                                >

                                                    {/* File Icon */}
                                                    <Icon
                                                        icon="weui:done2-filled"
                                                        width="20"
                                                        style={{
                                                            color: doc.status !== "APPROVED" ? "#22C55E" : "#BBBBBB",
                                                            marginLeft: "5px"
                                                        }}
                                                    />

                                                    {/* File Name + Size */}
                                                    <div className="d-flex flex-column flex-grow-1 mx-3">
                                                        <span style={smallText} className="file-name-truncate">
                                                            {(() => {
                                                                const full = doc.file;
                                                                const idx = full.lastIndexOf(".");
                                                                const name = full.slice(0, idx);
                                                                const ext = full.slice(idx);

                                                                const maxLen = 22;
                                                                if (full.length <= maxLen) return full;

                                                                const allowed = maxLen - ext.length - 3;
                                                                return name.slice(0, allowed) + "..." + ext;
                                                            })()}
                                                        </span>

                                                        <span style={smallestText}>{doc.size}</span>
                                                    </div>

                                                    {/* Delete Icon */}
                                                    {doc.status !== "APPROVED" && (
                                                        <Icon
                                                            icon="material-symbols:delete-outline"
                                                            color="#909090"
                                                            width="22"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => handleRemoveFile(doc.id)} // 🔥 Remove file
                                                        />
                                                    )}
                                                </div>

                                            </>
                                        )
                                            // <>
                                            //     <button
                                            //         className="btn d-flex align-items-center gap-1 px-4 py-3"
                                            //         style={{
                                            //             backgroundColor: "#DDF6FF",
                                            //             color: "#00AFEF",
                                            //             borderRadius: "10px",
                                            //             width: "220px",
                                            //         }}
                                            //         onClick={() => document.getElementById(`fileInput-${doc.id}`).click()}
                                            //     >
                                            //         <Icon icon="material-symbols:upload" width="18" />
                                            //         Upload document
                                            //     </button>
                                            //     <input
                                            //         type="file"
                                            //         id={`fileInput-${doc.id}`}
                                            //         className="d-none"
                                            //         accept="application/pdf,image/png,image/jpeg"
                                            //         onChange={(e) => handleFileUpload(e, doc.id)}
                                            //     />
                                            // </>


                                        }

                                    </div>


                                    {/* COLUMN 2 → STATUS TAG */}

                                    <div style={{ width: "25%", textAlign: "center" }}>
                                        {doc.status && (
                                            <div
                                                className="px-1 py-1 rounded-pill d-flex align-items-center justify-content-center gap-1"
                                                style={{
                                                    background: doc.status === "APPROVED" ? "#DAFFE8" : doc.statusColor,
                                                    color: doc.status === "APPROVED" ? "#22C55E" : "#606060",
                                                    fontWeight: "400",
                                                    fontSize: "12px",
                                                }}
                                            >
                                                {doc.status === "APPROVED" && (
                                                    <Icon
                                                        icon="material-symbols:done-all-rounded"
                                                        width="18"
                                                        color="#22C55E"
                                                    />
                                                )}

                                                {doc.status}
                                            </div>
                                        )}
                                    </div>

                                </div>

                            </div>
                        ))}
                        {/* ACTION BUTTONS */}
                        <div className="d-flex justify-content-end mt-4 gap-3">


                            <button
                                className=" px-5"
                                style={{ color: '#ffffff', background: "#00AFEF", border: "none", borderRadius: '10px' }}

                                onClick={handleSubmit}
                                disabled={loading}  // disable when loading
                            >
                                {loading && (
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                )}
                                {loading ? "Please wait..." : "Submit"}
                            </button>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    );
};

export default UploadDocument;
